import { ABSENCE_LETTER_VERSION } from "../../../../../constants/version";
import AbsenceLetterDetail from "../../absence-letter-v1/pages/absence-letter/absence-letter-detail";
import AbsenceLetterNBA from "../../absence-letter-v1/pages/absence-letter/absence-letter-list/absence-letter-nba";
import AbsenceLetterCreate from "../../absence-letter/pages/absence-letter/absence-letter-create";
import AbsenceLetterDetailV2 from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import AbsenceLetterEdit from "../../absence-letter/pages/absence-letter/absence-letter-edit";
import AbsenceLetterNBAV2 from "../../absence-letter/pages/absence-letter/absence-letter-list/absence-letter-nba";

export const absenceLetterNBARoutes = {
  absenceLetterNBAPage: {
    isAdmin: false,
    title: "1. Đơn xin nghỉ phép",
    path: "/procedure/absence-letter-nba",
    parentId: "procedure",
    component: () => {
      return ABSENCE_LETTER_VERSION === 1 ? <AbsenceLetterNBA /> : <AbsenceLetterNBAV2 />;
    },
  },
  createAbsenceLetterNBAPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-nba/create",
    parentId: "procedure",
    component: AbsenceLetterCreate,
  },
  detailAbsenceLetterNBAPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-nba/:applicationForLeaveId",
    parentId: "procedure",
    component: ABSENCE_LETTER_VERSION === 1 ? AbsenceLetterDetail : AbsenceLetterDetailV2,
  },
  editAbsenceLetterNBAPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-nba/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: AbsenceLetterEdit,
  },
};
